import AddressSelectionComponent from '../components/address-selection-component';
import ToggleElementComponent from "../components/toggle-element-component";
import {SubmitOnce} from "../../components/submit-once";

export default class RequestARideController {

  constructor() {
    $('[name="timezone"]').val(moment.tz.guess());

    const originAddressElement = $('#originAddressComponent');
    const destinationAddressElement = $('#destinationAddressComponent');
    new AddressSelectionComponent(originAddressElement, 'originAddress', 'originPlaceId');
    new AddressSelectionComponent(destinationAddressElement, 'destinationAddress', 'destinationPlaceId');
    originAddressElement.on('addressChanged', function(e, address) {
      $('.originAddress:first').html(address);
      $('#returnRideSection .destinationAddress').html(address);
    });
    destinationAddressElement.on('addressChanged', function(e, address) {
      $('.destinationAddress:first').html(address);
      $('#returnRideSection .originAddress').html(address);
    });

    new ToggleElementComponent($('.toggle-element'));
    new SubmitOnce();

    $('#passengerIsCustomerCheck').on("change", () => { this.checkAndSetCustomer(); });

    let today = new Date();

    let datePickerFirst = $('#passengerDob').pickadate({
      format: 'mmm dd, yyyy',
      formatSubmit: 'yyyy-mm-dd',
      hiddenName: true,
      max: today,
      selectYears: 120,
      selectMonths: true
    }).pickadate('picker');

    $('[name="tripType"]').change(() => {
      this.handleReturnRideSection();
    });

    this.handleReturnRideSection();
    this.handlePassengerAddressSection();
    this.handleSSNFieldAndInfo();

    this.setupEvents();
  }

  setupEvents() {
    $('#vehicle').on('change', () => {
      this.handlePassengerAddressSection();
      this.handleSSNFieldAndInfo();
    });
  }

  checkAndSetCustomer() {
    const customerFirstNameInput = $('#customerFirstName');
    const customerLastNameInput = $('#customerLastName');
    const customerEmailInput = $('#customerEmail');
    const customerPhoneInput = $('#customerPhone');
    const passengerEmailInput = $('#passengerEmail');
    const passengerPhoneInput = $('#passengerPhone');

    if ($('#passengerIsCustomerCheck')[0].checked === true) {
      customerFirstNameInput.prop('required', false);
      customerFirstNameInput.prop('disabled', true);
      customerFirstNameInput.val('');
      customerLastNameInput.prop('required', false);
      customerLastNameInput.prop('disabled', true);
      customerLastNameInput.val('');
      customerEmailInput.prop('required', false);
      customerEmailInput.prop('disabled', true);
      customerEmailInput.val('');
      customerPhoneInput.prop('required', false);
      customerPhoneInput.prop('disabled', true);
      customerPhoneInput.val('');

      passengerEmailInput.prop('required', true);
      passengerPhoneInput.prop('required', true);
    } else {
      customerFirstNameInput.prop('required', true);
      customerFirstNameInput.prop('disabled', false);
      customerLastNameInput.prop('required', true);
      customerLastNameInput.prop('disabled', false);
      customerEmailInput.prop('required', true);
      customerEmailInput.prop('disabled', false);
      customerPhoneInput.prop('required', true);
      customerPhoneInput.prop('disabled', false);

      passengerEmailInput.prop('required', false);
      passengerPhoneInput.prop('required', false);
    }
  }

  handleReturnRideSection() {

    if ($('[name="tripType"]').val() == 'round') {
      $('#returnRideSection').show();
    } else {
      $('#returnRideSection').hide();
    }
  }

  handlePassengerAddressSection() {
    const vehicle = $('#vehicle').val();
    const el = $('#passengerAddressSection');
    vehicle === 'bls' ? el.show() : el.hide();
  }

  handleSSNFieldAndInfo() {

    const vehicle = $('#vehicle').val();
    const ssnInfo = $('#ssnInfo');
    const ssnSection = $('#ssnSection');

    if (vehicle === 'bls') {
      ssnInfo.show();
      ssnSection.show();
    } else {
      ssnInfo.hide();
      ssnSection.hide();
      $('#passengerSSN').val('');
    }
  }
}
